import { render, staticRenderFns } from "./MailOverview.vue?vue&type=template&id=117f92ca"
import script from "./MailOverview.vue?vue&type=script&lang=js"
export * from "./MailOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports